import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { RoutesPath } from '../../../shared/constants/routes-path';
import { TranslateModule } from '@ngx-translate/core';
import { SHARED_COMPONENTS } from '../../../shared/shared-imports';

@Component({
  standalone: true,
  selector: 'app-uaepass-login',
  imports: [CommonModule, TranslateModule, ...SHARED_COMPONENTS],
  templateUrl: './uaepass-login.component.html',
  styleUrl: './uaepass-login.component.css'
})
export class UaePassLoginComponent implements OnInit {
  flowId = '';
  code = '';
  state = '';
  matchedUser = '';
  showLinkPrompt = false;
  isSubmitting = false;
  private readonly completeUrl = `${environment.wso2APIURL}DCAuthToken/InitiateUAEPassAuthREST/completeUAEPassAuth`;

  constructor(private route: ActivatedRoute, private router: Router, private http: HttpClient) {}

  ngOnInit(): void {
    this.flowId = sessionStorage.getItem('uaePassFlowId') || '';
    this.route.queryParams.subscribe((params) => {
      this.code = params['code'] || '';
      this.state = params['state'] || '';
      this.completeUaePassAuth();
    });
  }

  private completeUaePassAuth(): void {
    if (!this.flowId || !this.code || !this.state) {
      return;
    }
    if (this.isSubmitting) {
      return;
    }
    this.isSubmitting = true;
    this.http.post(this.completeUrl, {
      flowId: this.flowId,
      code: this.code,
      state: this.state,
      redirect_uri: environment.uaePassRedirectUri
    }).subscribe({
      next: (response: any) => {
        if (response?.access_token) {
          this.handleLoginSuccess(response, response?.username || response?.userName || this.matchedUser);
          return;
        }
        const messages = response?.nextStep?.messages || [];
        const accountLinkMessage = messages.find((message: any) => {
          const messageId = message?.messageId || '';
          const text = message?.message || '';
          return messageId === 'Account_linking' || text.includes('Matched Users');
        });

        if (accountLinkMessage) {
          const matchedUser = this.getMatchedUser(accountLinkMessage);
          if (matchedUser) {
            this.matchedUser = matchedUser;
            this.showLinkPrompt = true;
          }
        }
        this.isSubmitting = false;
      },
      error: () => {
        this.isSubmitting = false;
      }
    });
  }

  private getMatchedUser(message: any): string {
    const context = Array.isArray(message?.context) ? message.context : [];
    const usernameContext = context.find((item: any) => item?.key === 'usernames');
    if (usernameContext?.value) {
      return String(usernameContext.value).trim();
    }
    const emailContext = context.find((item: any) => item?.key === 'useremails');
    if (emailContext?.value) {
      return String(emailContext.value).trim();
    }
    const text = (message?.message || '').toString();
    const match = text.match(/Matched Users\s*:\s*(.+)/i);
    if (match?.[1]) {
      return match[1].trim();
    }
    return '';
  }

  proceedToLink(): void {
    if (!this.matchedUser) {
      return;
    }
    this.router.navigate(['/', RoutesPath.PUBLIC.LOGIN], {
      queryParams: { uaepassuser: this.matchedUser }
    });
  }

  backToSignIn(): void {
    this.router.navigate(['/', RoutesPath.PUBLIC.LOGIN]);
  }

  private handleLoginSuccess(response: any, username: string): void {
    const expiresIn = Number(response?.expires_in || 0);
    const expiresAt = expiresIn ? Date.now() + expiresIn * 1000 : null;
    const userData = {
      user: { username: username || '' },
      access_token: response.access_token,
      refresh_token: response.refresh_token,
      id_token: response.id_token,
      token: response.id_token || response.access_token,
      token_type: response.token_type,
      scope: response.scope,
      expiresAt
    };
    localStorage.setItem('login_user', JSON.stringify(userData));
    this.router.navigate([RoutesPath.DASHBOARD]);
  }
}
